// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fb959073","627":"794b1bfe","653":"94cea245","738":"58f8f862","828":"f36974eb","923":"e2cbe7f8"}[chunkId] + ".chunk.js";
};